import React from 'react';

import { Divider, Link } from '@fluentui/react-components';
import { mergeStyleSets } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

interface IAboutUsProps {
  className?: string;
}

const Footer = (props: IAboutUsProps) => {
  const { t } = useTranslation();

  return (
    <div className={`${props.className} ${styles.container}`}>
      <Link href='./#/AboutUs#fb' target='_blank'>
        {t('UserFeedback')}
      </Link>
      <Divider vertical style={{ height: 16 }} />
      <Link href='./#/AboutUs#au' target='_blank'>
        {t('AboutUs')}
      </Link>
      <Divider vertical style={{ height: 16 }} />
      <Link href='./#/AboutUs#tm' target='_blank'>
        {t('Terms')}
      </Link>
    </div>
  );
};

export default Footer;

const styles = mergeStyleSets({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    lineHeight: 50,

    '& > *': {
      flexGrow: '0 !important'
    },

    '& > a': {
      margin: '0 32px !important'
    }
  }
});
